//https://github.com/8Tesla8/utc-to-local-time/blob/main/src/app/utc-pipe/utc-to-local-time.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { UtcConverterService } from '@app-services/utc-converter.service';

@Pipe({
    name: 'utcToLocalTime',
})
export class UtcToLocalTimePipe implements PipeTransform {
    
    constructor(private _dateConverter: UtcConverterService) {
    }

    transform(date?: string | null, args?: any): string {
        return this._dateConverter.convertUtcToLocalTime(date!, args);
    }
}